// extracted by mini-css-extract-plugin
export default {"wrapper":"Xy-z","viewport":"Yy-z","container":"Zy-z","slide":"_y-z"};